import React from 'react';
import '../StyleSheets/ExpandedPolicyEvent.css';


export default class ExpandedPolicyEvent extends React.Component {

    render() {
        const { t,c,s } = this.props.data;

        const paragraphs = t.split( "</br>" );

        return <div id="expandedPolityContainer">
            <div id="policyContentPanel">
                <div id="closePolicy"
                    onClick={ this.props.onClose }
                >סגירה</div>
                <div id="severityIndicator" style={{backgroundColor: c}}>{ "רמת חומרה: " + s}</div>
                <div id="eventTextContainer">{paragraphs.map( (p,i) => <p key={"eventTextPara"+i}>{p}</p>)}</div>
            </div>
        </div>
    }

}